import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    AuctionsLoadedAction,
    LoadAuctionsFailedAction,
    AuctionsPageUIActions,
    LoadAuctionsAction,
} from './auctions-page.actions';
import {
    AuctionCatalogsService as AuctionsService,
    GetFeaturedAuctions200Response,
} from '@viewbid/ts-angular-client';

@Injectable()
export class AuctionsPageEffects {
    loadActions$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AuctionsPageUIActions.LoadAuctionsAction),
            switchMap((action: LoadAuctionsAction) => {
                return this.auctionService
                    .getAuctions(
                        action.props.page,
                        action.props.size,
                        action.props.filter,
                    )
                    .pipe(
                        map((result: GetFeaturedAuctions200Response) => {
                            return new AuctionsLoadedAction({
                                result: result,
                            });
                        }),
                        catchError((_error: Error) => {
                            return of(new LoadAuctionsFailedAction());
                        }),
                    );
            }),
        );
    });

    constructor(
        private actions$: Actions,
        private auctionService: AuctionsService,
    ) {}
}
